// Звуки слота: синтез WebAudio, без файлов. Перенесено из прототипа как есть.
// AudioContext создаётся при первом звуке (он всегда идёт после нажатия игрока — iOS/Telegram это требуют).

export function createSound(isEnabled) {
  let ctx = null;

  function tone(f, d, type, v, delay, slide) {
    if (!isEnabled()) return;
    try {
      ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
      if (ctx.state === 'suspended') ctx.resume();
      const t0 = ctx.currentTime + (delay || 0), o = ctx.createOscillator(), g = ctx.createGain();
      o.type = type || 'sine';
      o.frequency.setValueAtTime(f, t0);
      if (slide) o.frequency.exponentialRampToValueAtTime(slide, t0 + d);
      g.gain.setValueAtTime(v, t0);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + d);
      o.connect(g).connect(ctx.destination);
      o.start(t0); o.stop(t0 + d + 0.02);
    } catch (e) { /* звук не обязателен */ }
  }
  const seq = (notes, step, type, v) => notes.forEach((f, i) => tone(f, step * 1.9, type, v, i * step));

  return {
    spin: () => tone(200, 0.14, 'triangle', 0.05, 0, 420),
    stop: () => tone(125, 0.08, 'triangle', 0.15, 0, 70),
    scatter: n => { tone(520 * Math.pow(1.26, n), 0.5, 'sine', 0.2); tone(1040 * Math.pow(1.26, n), 0.3, 'sine', 0.08, 0.05); },
    antic: ms => tone(170, ms / 1000, 'sawtooth', 0.035, 0, 760),
    win: x => seq(x >= 5 ? [523, 659, 784, 1047, 1319] : x >= 1 ? [523, 659, 784] : [523, 659], 0.07, 'square', 0.045),
    big: () => seq([392, 523, 659, 784, 1047, 1319, 1568, 2093], 0.11, 'square', 0.055),
    bonus: () => seq([523, 523, 659, 784, 659, 784, 1047, 1047, 1319, 1568], 0.12, 'sawtooth', 0.05),
    step: k => tone(330 * Math.pow(1.06, k), 0.12, 'triangle', 0.09),
    tick: () => tone(1500, 0.025, 'square', 0.035),
    destroy: () => { try { if (ctx) ctx.close(); } catch (e) { /* уже закрыт */ } ctx = null; },
  };
}
